import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { confirm } from "./thunks/confirm";
import { listContactLogs } from "./thunks/list-contact-logs";
import { listGeoCatalog } from "./thunks/list-geo-catalog";
import { listPending } from "./thunks/list-pending";
import { listZones } from "./thunks/list-zones";
import { logContact } from "./thunks/log-contact";
import { updateAddress } from "./thunks/update-address";
import { addAddress } from "./thunks/add-address";

const name = "pendingConfirmation";

export const slice = createSlice({
  name,
  initialState,
  reducers: {
    clearLogs: (state) => {
      state.logs = [];
    },
  },
  extraReducers: (builder) => {
    builder
      // Only the latest call lands: with the search box firing a call per
      // pause, an earlier search can answer after a later one (DMS-69).
      .addCase(listPending.pending, (state, action) => {
        state.listRequestId = action.meta.requestId;
        state.isPending = true;
        state.isRejected = false;
        state.errorMessage = "";
      })
      .addCase(listPending.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.listRequestId) return;
        state.queue = action.payload.items;
        state.page = action.payload.page;
        state.pageSize = action.payload.pageSize;
        state.totalItems = action.payload.totalItems;
        state.totalPages = action.payload.totalPages;
        state.statusCounts = action.payload.statusCounts;
        state.isPending = false;
      })
      .addCase(listPending.rejected, (state, action) => {
        if (action.meta.requestId !== state.listRequestId) return;
        state.isPending = false;
        state.isRejected = true;
        state.errorMessage = action.error.message ?? "";
      })
      .addCase(listZones.fulfilled, (state, action) => {
        state.zones = action.payload;
      })
      .addCase(listGeoCatalog.fulfilled, (state, action) => {
        state.geoCatalog = action.payload;
      });

    builder
      .addCase(updateAddress.pending, (state) => {
        state.isSavingAddress = true;
      })
      .addCase(updateAddress.fulfilled, (state) => {
        state.isSavingAddress = false;
      })
      .addCase(updateAddress.rejected, (state) => {
        state.isSavingAddress = false;
      })
      .addCase(addAddress.pending, (state) => {
        state.isSavingAddress = true;
      })
      .addCase(addAddress.fulfilled, (state) => {
        state.isSavingAddress = false;
      })
      .addCase(addAddress.rejected, (state) => {
        state.isSavingAddress = false;
      });

    builder
      .addCase(confirm.pending, (state) => {
        state.isActing = true;
        state.actionError = "";
      })
      .addCase(confirm.fulfilled, (state) => {
        state.isActing = false;
      })
      .addCase(confirm.rejected, (state, action) => {
        state.isActing = false;
        state.actionError = action.error.message ?? "";
      });

    builder
      .addCase(listContactLogs.pending, (state) => {
        state.isLoadingLogs = true;
      })
      .addCase(listContactLogs.fulfilled, (state, action) => {
        state.logs = action.payload;
        state.isLoadingLogs = false;
      })
      .addCase(listContactLogs.rejected, (state) => {
        state.isLoadingLogs = false;
      });

    builder
      .addCase(logContact.pending, (state) => {
        state.isLogging = true;
      })
      .addCase(logContact.fulfilled, (state, action) => {
        state.isLogging = false;
        state.logs.push(action.payload);
      })
      .addCase(logContact.rejected, (state) => {
        state.isLogging = false;
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
